<template>
  <router-view/>
</template>

<script>
import { clearAuthenticatedBodyShell } from '../../helpers/authShell';

export default {
  name: "Guest",
  mounted() {
    clearAuthenticatedBodyShell();
  },
}
</script>

<style scoped>

</style>
